import React, { useState } from 'react';
import { UserIcon, MenuIcon, SearchIcon, X } from 'lucide-react';
import { SearchBar } from './SearchBar';
import { Link } from 'react-router-dom';
import { MobileSearch } from './MobileSearch';
export const Header = () => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const handleSearchClick = () => {
    setShowMobileSearch(true);
  };
  return <>
      <header className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white" data-id="element-120">
        <div className="flex items-center" data-id="element-121">
          <Link to="/" className="text-rose-500 text-2xl font-bold" data-id="element-122">
            airspace
          </Link>
        </div>
        {/* Search Bar - hidden on mobile, visible on larger screens */}
        <div className="hidden md:block flex-1 max-w-xl mx-4" data-id="element-123">
          <SearchBar data-id="element-124" />
        </div>
        <div className="flex items-center gap-4" data-id="element-125">
          {/* Mobile Search Icon */}
          <button className="md:hidden text-gray-600 hover:text-gray-900 p-2" onClick={handleSearchClick} data-id="element-126">
            <SearchIcon size={20} data-id="element-127" />
          </button>
          <div className="hidden md:block text-sm font-medium px-4 py-2 rounded-full hover:bg-gray-100 transition cursor-pointer" data-id="element-128">
            Become a Host
          </div>
          <div className="flex items-center gap-2 border rounded-full p-2 cursor-pointer hover:shadow-md transition" data-id="element-129">
            <MenuIcon size={18} data-id="element-130" />
            <div className="bg-gray-500 rounded-full p-1 text-white" data-id="element-131">
              <UserIcon size={18} data-id="element-132" />
            </div>
          </div>
        </div>
      </header>
      {/* Mobile Search Overlay */}
      {showMobileSearch && <MobileSearch onClose={() => setShowMobileSearch(false)} data-id="element-133" />}
    </>;
};